export { default as Avatar } from './Avatar'
